export default "__VITE_ASSET__K5u55kMz__"